import { render, staticRenderFns } from "./PPMBin.vue?vue&type=template&id=6c95f228&scoped=true&"
import script from "./PPMBin.vue?vue&type=script&lang=ts&"
export * from "./PPMBin.vue?vue&type=script&lang=ts&"
import style0 from "./PPMBin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PPMBin.vue?vue&type=style&index=1&id=6c95f228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c95f228",
  null
  
)

component.options.__file = "PPMBin.vue"
export default component.exports